// ts enum for ResultView
export enum ResultView {
  List = 0,
  Card = 1,
  Gallery = 2,
}